import TrainingSourceSettingsForm from "@/admin/training-sources/TrainingSourceSettingsForm"
import {
  TrainingSourceKind,
  TrainingSourceSettingsFormFragment$key,
} from "@/admin/training-sources/__generated__/TrainingSourceSettingsFormFragment.graphql"
import { DiscoModal } from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import { TestIDProps } from "@utils/typeUtils"

interface TrainingSourceSettingsButtonProps extends TestIDProps {
  trainingSourceKey: TrainingSourceSettingsFormFragment$key
  kind: TrainingSourceKind
  children: OverridableDiscoButtonChildren
}

function TrainingSourceSettingsButton({
  trainingSourceKey,
  kind,
  testid = "TrainingSourceSettingsButton",
  children,
}: TrainingSourceSettingsButtonProps) {
  const label = kind === "web_crawl" ? "Link" : "Knowledge Base"
  return (
    <OverridableDiscoButton
      modal={({ isOpen, onClose }) => {
        if (!isOpen) return null

        return (
          <DiscoModal
            testid={testid}
            modalContentLabel={"Training Source Settings Modal"}
            title={`${label} Settings`}
            isOpen
            onClose={onClose}
            width={"520px"}
            buttons
            body={
              <TrainingSourceSettingsForm
                trainingSourceKey={trainingSourceKey}
                onClose={onClose}
                kind={kind}
                onSubmit={onClose}
              />
            }
          />
        )
      }}
    >
      {children}
    </OverridableDiscoButton>
  )
}

export default TrainingSourceSettingsButton
